import React, { Component } from 'react';
import * as d3 from 'd3';
import { select } from 'd3-selection'

export class Slice extends Component {
    constructor(props) {
        super(props)
       // this.updateContent = this.updateContent.bind(this)
    }
    //componentDidUpdate() {
    //    this.updateContent()
    //}
    //updateContent() {
    //    const node = this.node
    //    select(node)
    //        .selectAll('text').call(wrap)
    //}

    render() {
        let { value, label, fill, innerRadius = 10, outerRadius } = this.props;
        let arc = d3.arc()
            .innerRadius(innerRadius)
            .outerRadius(outerRadius);
        let arcText = d3.arc()
            .innerRadius(outerRadius * .8)
            .outerRadius(outerRadius * .9);
        let arcDot = d3.arc()
            .innerRadius(outerRadius / this.props.dot)
            .outerRadius(outerRadius / this.props.dot);
        return (
            <React.Fragment>
                <g>
                    <path d={arc(value)} fill={fill} />
                    {/* https://github.com/d3/d3/wiki/SVG-Shapes#arc_centroid */}
                    <text transform={`translate(${arcDot.centroid(value)})`}
                        dy=".35em"
                        textAnchor="middle"
                        className="svgDot"
                        fill="white">
                        {"."}
                    </text>
                    <text transform={`translate(${arcText.centroid(value)})`}
                        dy=".35em"
                        width="100"                        
                        textAnchor="middle"
                        className="svgText"
                        fill="black">
                        {label}
                    </text>

                </g>
            </React.Fragment>
        );
    }
}

function wrap(element, width) {
    var text = select('.wrapme')
    var words = text.text().split(/\s+/).reverse();
    var lineHeight = 20;
    var width = parseFloat(text.attr('width'));
    var y = parseFloat(text.attr('y'));
    var x = text.attr('x');
    var anchor = text.attr('text-anchor');

    var tspan = text.text(null).append('tspan').attr('x', x).attr('y', y).attr('text-anchor', anchor);
    var lineNumber = 0;
    var line = [];
    var word = words.pop();

    while (word) {
        line.push(word);
        tspan.text(line.join(' '));
        if (tspan.node().getComputedTextLength() > width) {
            lineNumber += 1;
            line.pop();
            tspan.text(line.join(' '));
            line = [word];
            tspan = text.append('tspan').attr('x', x).attr('y', y + lineNumber * lineHeight).attr('anchor', anchor).text(word);
        }
        word = words.pop();
    }
}


// WEBPACK FOOTER //
// ./src/components/common/Slice.js